export default "__VITE_ASSET__61e7a447__"